import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useEmailTypoSuggestion } from '../hooks/useEmailTypoSuggestion';

const EmailTypoSuggestion = ({ inputSelector, debounceMs = 1000 }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current = document.querySelector(inputSelector);
  }, [inputSelector]);

  const { suggestion, applySuggestion, dismissSuggestion } =
    useEmailTypoSuggestion({
      inputRef,
      debounceMs,
    });

  if (!suggestion) return null;

  return (
    <div
      role="alert"
      className="email-typo-suggestion-alert"
      aria-live="polite"
    >
      <span>
        <i className="fa fa-regular fa-question-circle" aria-hidden="true" />{' '}
        {I18n.t('form_element_widget.show.email_suggestion')}{' '}
        <button
          type="button"
          className="btn btn-link p-0 align-baseline"
          onClick={applySuggestion}
          aria-label={I18n.t(
            'form_element_widget.show.email_suggestion_confirm',
            { email: suggestion.suggested }
          )}
        >
          <strong>{suggestion.suggested}</strong>
        </button>
        ?
      </span>
      <button
        type="button"
        className="btn p-0 ms-2"
        onClick={dismissSuggestion}
        aria-label={I18n.t('form_element_widget.show.email_suggestion_dismiss')}
      >
        <i className="fa fa-times" aria-hidden="true" />
      </button>
    </div>
  );
};

EmailTypoSuggestion.propTypes = {
  inputSelector: PropTypes.string.isRequired,
  debounceMs: PropTypes.number,
};

export default EmailTypoSuggestion;
